import { Errors } from 'components/Form/InputError'
import { Campaign } from 'types/campaign'

export type FormData = {
  campaignId: Campaign['id']
  campaignStartDate: Campaign['startDate'] | null
  campaignEndDate: Campaign['endDate'] | null
}

export const formDataDefault: FormData = {
  campaignId: '',
  campaignStartDate: null,
  campaignEndDate: null,
}

export interface FormDataErrors {
  campaignId: Errors
}

export const formDataErrorsDefault: FormDataErrors = {
  campaignId: [],
}
